import { render, staticRenderFns } from "./ReportCardDetail.vue?vue&type=template&id=5d1d0c34&scoped=true"
import script from "./ReportCardDetail.vue?vue&type=script&lang=ts"
export * from "./ReportCardDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardDetail.vue?vue&type=style&index=0&id=5d1d0c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d0c34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyState: require('/app/components/Common/EmptyState.vue').default,UIReportCardGrade: require('/app/components/Common/UI2/Grade/UIReportCardGrade.vue').default,ReportCardDimensionRow: require('/app/components/Run/ReportCard/ReportCardDimensionRow.vue').default})
